import * as React from "react";
import { useTranslation } from "react-i18next";
import QueryHelper from "components/common/QueryHelper";
const QUERY_EXAMPLE = "pattern:critical";
const ReportQueryHelper = () => {
  const { t } = useTranslation("enterprise_report");
  const queryExample = /* @__PURE__ */ React.createElement("p", null, t("reports_query_helper.example"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("kbd", null, QUERY_EXAMPLE), /* @__PURE__ */ React.createElement("br", null));
  const fieldMap = {
    subtitle: t("reports_query_helper.subtitle"),
    description: t("reports_query_helper.description")
  };
  return /* @__PURE__ */ React.createElement(
    QueryHelper,
    {
      example: queryExample,
      entityName: t("reports_query_helper.entity_name"),
      commonFields: ["title"],
      fieldMap
    }
  );
};
export default ReportQueryHelper;
